import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import * as logger from '../../../logger';
import { Form } from 'react-final-form';
import TextInputState from '../Inputs/TextInputState';
import CloseIcon from '@material-ui/icons/Close';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
import { connect } from 'react-redux';
import { editInvoice } from '../../../store/actions/tripActionCreator';
import { trackDwebEvent } from '../../analytics';
import { getMilliDatePickerDateInStringDDMMMYYYY } from '../../../utils/utils';


const useStyles = makeStyles(() => ({

    paperWidthV1: {
        width: '420px !important'
    },
    brV1: {
        borderRadius: '8px !important'
    },
    dialogTitleV1: {
        paddingTop: 10,
        paddingBottom: '10px !important',
        paddingLeft: 30,
        paddingRight: 18,
        backgroundColor: 'white'
    },
    divAlignTitle: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    titleText: {
        fontSize: 20,
        fontWeight: 600,
        color: '#0b1323'
    },
    closeIcon: {
        color: '#9ea0a5',
        fontSize: 20
    },
    dialogContentV1: {
        paddingBottom: '32px !important',
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: '#f6f6f8'
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#161f34',
        color: 'white',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#161f34'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#e2e2e2 !important',
        color: 'rgba(11, 19, 35, 0.6) !important',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#e2e2e2 !important'
        }
    },
    cancelButton: {
        padding: '6px 20px',
        borderRadius: '4px',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        marginRight: 16,
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)'
        }
    },
    dialogActionV1: {
        paddingRight: 30,
        paddingLeft: 30,
        paddingTop: 20,
        paddingBottom: 20
    }

}));

const TermsAndConditionsDialog = ({ open, onClose, onConfirm, termsValue, invoiceId, dispatchEditInvoice, trip }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [termsAndConditionsValue, setTermsAndConditionsValue] = useState("");
    const [confirmDisabled, setConfirmDisabled] = useState(false);

    const classes = useStyles();

    useEffect(() => {
        setTermsAndConditionsValue(termsValue);
    }, [open]);

    const initialValues = {
        termsAndCondition: termsAndConditionsValue
    }

    const getFormFields = values => {

        return [
            {
                size: 12,
                visible: true,
                field: (
                    <>
                        <TextInputState
                            multiline={true}
                            rows="7"
                            placeholder="Enter Terms and Conditions"
                            name="termsAndCondition"
                            variant="outlined"
                            size="small"
                            onChange={(e) => { setTermsAndConditionsValue(e.target.value) }}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </>
                )
            }
        ]

    }

    const onSubmit = values => {

        const reqData = {
            otherDetails: {
                termsAndConditions: values && values.termsAndCondition ? values.termsAndCondition : ""
            }
        }

        dispatchEditInvoice(invoiceId, reqData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Terms and Conditions Dialog Dweb', 'Edit Invoice Successfull');
                    onConfirm(values.termsAndCondition);
                    if (data.response) {
                        const invoiceInfo = data.response;
                        trackDwebEvent('Dweb Invoice edit More info changed', {
                            party_name: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerName ? invoiceInfo.invoiceDetails.customerName : "",
                            party_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.customerId ? invoiceInfo.invoiceDetails.customerId : "",
                            count_of_trips: invoiceInfo && invoiceInfo.trips && invoiceInfo.trips.length ? invoiceInfo.trips.length : 0,
                            total_invoice_amount: invoiceInfo && invoiceInfo.amounts && invoiceInfo.amounts.total ? invoiceInfo.amounts.total : "",
                            invoice_number: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceNumber ? invoiceInfo.invoiceDetails.invoiceNumber : "",
                            invoice_date: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.invoiceDate ? getMilliDatePickerDateInStringDDMMMYYYY(invoiceInfo.invoiceDetails.invoiceDate) : "",
                            due_days: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.dueIn ? invoiceInfo.invoiceDetails.dueIn : 0,
                            invoice_id: invoiceInfo && invoiceInfo.invoiceDetails && invoiceInfo.invoiceDetails.id ? invoiceInfo.invoiceDetails.id : "",
                            party_company_name: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.companyName ? invoiceInfo.customerGSTDetails.companyName : "",
                            party_gst_number: invoiceInfo && invoiceInfo.customerGSTDetails && invoiceInfo.customerGSTDetails.gstNumber ? invoiceInfo.customerGSTDetails.gstNumber : "",
                            user_company_name: invoiceInfo && invoiceInfo.userGSTDetails && invoiceInfo.userGSTDetails.companyName ? invoiceInfo.userGSTDetails.companyName : "",
                            user_gst_number: invoiceInfo && invoiceInfo.userGSTDetails && invoiceInfo.userGSTDetails.gstNumber ? invoiceInfo.userGSTDetails.gstNumber : "",
                            gst_percentage: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.gstPercentage ? invoiceInfo.otherDetails.gstPercentage : "",
                            terms_and_conditions: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.termsAndConditions ? invoiceInfo.otherDetails.termsAndConditions : "",
                            signature_url: invoiceInfo && invoiceInfo.otherDetails && invoiceInfo.otherDetails.signatureLink ? invoiceInfo.otherDetails.signatureLink : ""
                        })
                    }
                }
            },
            () => {
                logger.log('Terms and Conditions Dialog Dweb', 'Edit Invoice Failed');
            }
        )

    }

    const validate = values => {
        const errors = {};

        if (values && !values.termsAndCondition) {
            setConfirmDisabled(true);
        } else {
            setConfirmDisabled(false);
        }

        return errors;
    }

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
    }

    return (
        <>
            <Dialog
                open={dialogOpen}
                onClose={handleClose}
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                classes={{ paperWidthXs: classes.paperWidthV1, paperScrollPaper: classes.brV1 }}
                maxWidth="xs"
            >

                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divAlignTitle}>
                        <div className={classes.titleText}>Add Terms and Condtitions</div>
                        <IconButton aria-label="close" onClick={handleClose}>
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>
                    <Form
                        onSubmit={onSubmit}
                        initialValues={initialValues}
                        validate={validate}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit; return (
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container alignItems="flex-start" spacing={0}>
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />
                </DialogContent>

                <DialogActions className={classes.dialogActionV1}>
                    <Button variant="contained" className={classes.cancelButton} onClick={() => handleClose()}>
                        Close
                    </Button>
                    <Button variant="contained" className={classes.saveButton} classes={{ disabled: classes.saveButtonDisabled }} disabled={confirmDisabled}
                        onClick={event => submit(event)}
                    >
                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchEditInvoice: (invoiceId, reqData, onSuccess, onError) => {
        dispatch(editInvoice(invoiceId, reqData, onSuccess, onError))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(TermsAndConditionsDialog);